<template>
  <div 
    id="dadosOrcamento"
    @click="$emit('close')"
    style="display: block; line-height:17px!important;"
    class="w3-modal" 
    v-cloak>
    
    <div class="w3-modal-content" @click.stop v-cloak>
      <header class="" v-cloak>
        <span @click="$emit('close')" class="w3-button w3-display-topright">&times;</span>
        <h5 class="texto-vermelho titulo">Dados do Orçamento</h5>
      </header>
    
      <div class="w3-container">
        <div class="cabecalho w3-col">
          
          <div class="w3-col l6 m6 w3-left texto-vermelho">
            <strong>{{orcamento.orcamento_id}}</strong>
          </div>

          <div class="w3-col texto-verde" v-if="orcamento.total_pedido == orcamento.total_geral">
            <label></label>
            <strong>R${{orcamento.total_pedido}}</strong>
          </div>
          
          <div class="w3-col" v-if="orcamento.total_pedido != orcamento.total_geral">
            
            <label>Total pedido:</label>
            <strong>R${{orcamento.total_pedido}}</strong>
          </div>

          <div class="w3-col" v-if="orcamento.total_pedido != orcamento.total_geral">
            
            <label>Total geral:</label>
            <strong>R${{orcamento.total_geral}}</strong>
          </div> 

          <div class="w3-col">
            <legenda>
              <div>Cliente</div>
                <i slot="referencia" class="fa fa-user-tag texto-vermelho"/>
            </legenda>
            <strong>{{orcamento.nome_cliente}}</strong>
          </div>

          <div class="w3-col">
            <legenda>
              <div>Nome do vendedor</div>
              <i slot="referencia" class="fa fa-user-tie texto-vermelho"/>
            </legenda>
            <label>{{orcamento.nome_vendedor}}</label>
          </div>

          <div  
            v-if="status_orcamento.st_status_cor != undefined" 
            class="w3-col ">
            <div 
              v-if=" status_orcamento.st_status_cor != '#C0C0C0'"
              :style="{'color': status_orcamento.st_status_cor}">
              
              <strong>{{ status_orcamento.st_status_texto }}</strong>
            </div>
            
          </div>  
        </div>
      </div>
      
      <h6
        @click="mostrarGerais()" 
        v-if="!mostrar_gerais" 
        class="fundo-cabecalho">&nbsp;
        <span>
          <i class="fas fa-sort"/>
        </span>&nbsp;
        <i class="fas fa-file-invoice-dollar" />&nbsp;&nbsp;&nbsp;
        <a href="#" >Dados gerais</a> 
      </h6>
      
      <h6 
        @click="mostrarGerais()" 
        v-if="mostrar_gerais" 
        class="fundo-cabecalho">&nbsp;
        <span>
          <i class="fas fa-sort-down"/>
        </span>&nbsp;
        <i class="fas fa-file-invoice-dollar"/>&nbsp;&nbsp;&nbsp;
        <a href="#" >Dados gerais</a>
      </h6>
      
      <div v-if="mostrar_gerais" class="w3-animate-zoom w3-container">
        <div
          v-if="status_orcamento.st_acao_cor != '#c0c0c0'"
          :style="{'color': status_orcamento.st_acao_cor}">
          <strong>{{ status_orcamento.st_acao_texto }}</strong>
        </div>
        
        <div 
          v-if="status_orcamento.st_recebimento_entrega_cor != '#c0c0c0' "
          :style="{'color': status_orcamento.st_recebimento_entrega_cor}">
          <strong>{{ status_orcamento.st_recebimento_entrega_texto }}</strong>
        </div>
        
        <div 
          v-if="status_orcamento.st_tipo_entrega_cor != '#C0C0C0'" 
          :style="{'color': status_orcamento.st_tipo_entrega_cor}">
          <strong>{{ status_orcamento.st_tipo_entrega_texto }}</strong>
        </div>
        
        <div 
          v-if="status_orcamento.st_venda_rapida_cor != '#C0C0C0'" 
          :style="{'color': status_orcamento.st_venda_rapida_cor}">
          <strong>{{ status_orcamento.st_venda_rapida_texto }}</strong>
        </div>
        
        <div 
          v-if="status_orcamento.st_gerado_automaticamente_cor != '#C0C0C0'" 
          :style="{'color': status_orcamento.st_gerado_automaticamente_cor}">
          <strong>{{ status_orcamento.st_gerado_automaticamente_texto }}</strong>
        </div>
        
        <div 
          class="w3-col l6 m6 texto-vermelho"
          v-if="orcamento.data_cadastro == 
          orcamento.data_fechamento && 
          orcamento.data_cadastro ==
          orcamento.data_recebimento ">
          
          <strong>{{orcamento.data_cadastro}}</strong>
        </div>

        <div class="w3-col l6 m6" v-if="orcamento.empresa_recebimento">
          <label>Empresa de recebimento: </label>
          <strong>{{orcamento.empresa_recebimento}}</strong>
        </div>

        <div class="w3-col">
          <legenda>
            <div>Condição de pagamento</div>
            <i slot="referencia" class="fas fa-credit-card texto-vermelho"/>
          </legenda>
          <label>&nbsp;{{orcamento.condicao_pagamento}}</label>
        </div>

        <div class="w3-col">
          <legenda>
              <div>Empresa da venda</div>
              <i slot="referencia" class="fa fa-building texto-vermelho"/>
          </legenda>
          <label>&nbsp;&nbsp;{{orcamento.empresa_venda}}</label>
        </div>

        <div class="w3-col" v-if="orcamento.total_produto != orcamento.total_geral">
          <label>Total produtos:</label>
          <strong>R${{ orcamento.total_produto }} </strong>
        </div>
        
        <div class="w3-col" v-if="npz(orcamento.total_servico)">
          <label>Total serviços:</label>
          <strong> <span style="color:#2e6730">R$ {{ orcamento.total_servico }}</span></strong>
        </div> 
      
        <div class="w3-col" v-if="npz(orcamento.valor_outras_despesas)">
          <label>Outras despesas:</label>
          <strong> <span style="color:#2e6730">R$ {{ orcamento.valor_outras_despesas }}</span></strong>
        </div> 

        <div class="w3-col" v-if="npz(orcamento.valor_desconto)">
          <label>Valor desconto:</label>
          <strong> <span style="color:#9c1d1c">R$ {{ orcamento.valor_desconto }}</span></strong>
        </div> 
        
        <div class="w3-col" v-if="npz(orcamento.valor_subst_trib)">
          <label>Subst. tribu.:</label>
          <strong> <span style="color:#2e6730">R$ {{ orcamento.valor_subst_trib }}</span></strong>
        </div>

        <div class="w3-col" v-if="npz(orcamento.valor_fcp_st)">
          <label>FCP ST:</label>
          <strong> <span style="color:#2e6730">R$ {{ orcamento.valor_fcp_st }}</span></strong>
        </div>

        <div class="w3-col" v-if="npz(orcamento.valor_ipi)">
          <label>Valor do IPI:</label>
          <strong> <span style="color:#2e6730">R$ {{ orcamento.valor_ipi }}</span></strong>
        </div>
          
        <div class="w3-col" v-if="npz(orcamento.valor_desc_imposto_retido)">
          <label>Desc. imp. ret:</label>
          <strong> <span style="color:#9c1d1c">R$ {{ orcamento.valor_desc_imposto_retido }}</span></strong>
        </div>

          
        <div class="w3-col"  v-if="orcamento.vendedor_externo">
          <label>Vendedor externo:</label>
          <strong> {{orcamento.vendedor_externo}} </strong>
        </div>

        <div class="w3-col"  v-if="orcamento.pessoa_autorizada">
          <label>Pessoa autorizada:</label>
          <strong> {{orcamento.pessoa_autorizada}} </strong>
        </div>

        <div class="w3-col"  v-if="orcamento.usuario_gerou_recebimento_entrega">
          <label>Usuário que gerou documentos no caixa:</label>
          <strong> {{orcamento.usuario_gerou_recebimento_entrega}} </strong>
        </div>
          
        <div 
          class="w3-col" 
          v-if="orcamento.data_cadastro !=
          orcamento.data_fechamento && 
          orcamento.data_cadastro != 
          orcamento.data_recebimento">
          <label>Data cadastro:</label>
          <strong>{{orcamento.data_cadastro}}</strong>
        </div>

        <div 
          class="w3-col" 
          v-if="(orcamento.data_fechamento && (orcamento.data_cadastro != orcamento.data_fechamento))">
          <label>Data fechamento:</label>
          <strong>{{orcamento.data_fechamento}}</strong>
        </div>

        <div 
          class="w3-col" 
          v-if="(orcamento.data_recebimento && (orcamento.data_cadastro != orcamento.data_recebimento))">
          <label>Data recebimento:</label>
          <strong>{{orcamento.data_recebimento}}</strong>
        </div>

        <div class="w3-col" v-if="npz(orcamento.valor_credito_manual)">
          <label>Crédito manual:</label>
          <strong> {{orcamento.valor_credito_manual}} </strong>
        </div>

        <div class="w3-col" v-if="npz(orcamento.valor_impulso)">
          <label>Valor impulso:</label>
          <strong> {{orcamento.valor_impulso}} </strong>
        </div>

        <div class="w3-col" v-if="orcamento.acumulativo_id != 0">
          <label>Acumulativo: </label>
          <strong> {{orcamento.acumulativo_id}} </strong>
        </div>

        <div class="w3-col" v-if="orcamento.entrada_id != 0">
          <label>Entrada:</label>
          <strong> {{orcamento.entrada_id}} </strong>
        </div>

        <div class="w3-col" v-if="orcamento.ordem_servico_id != 0">
          <label>Ordem serviço:</label>
          <strong> {{orcamento.ordem_servico_id}} </strong>
        </div>

        <div class="w3-col" v-if="npz(orcamento.valor_desconto_pis)">
          <label>Vlr. desconto PIS:</label>
          <strong> {{orcamento.valor_desconto_pis}} </strong>
        </div>

        <div class="w3-col"  v-if="npz(orcamento.valor_desconto_cofins)">
          <label>Vlr. desc. COFINS:</label>
          <strong> {{orcamento.valor_desconto_cofins}} </strong>
        </div>
        
        <h6 v-if="npz(orcamento.total_frete)" class="">&nbsp;
          <a href="#"><strong>Frete</strong></a> &nbsp;
          <i class="fas fa-shipping-fast"/>
        </h6>
          
        <div class="w3-container">
          <div class="w3-col" v-if="npz(orcamento.total_frete)">
            <label>Total frete:</label>
            <strong> <span style="color:#9c1d1c">R$ {{orcamento.total_frete}}</span></strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete)">
            <label>Tipo:</label>
            <strong> {{orcamento.tipo_frete}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete)">
            <label>Valor do frete:</label>
            <strong> {{orcamento.valor_frete}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete_extra_manual)">
            <label>Frete extra manual:</label>
            <strong> {{orcamento.valor_frete_extra_manual}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete_adicional)">
            <label>Frete adicional:</label>
            <strong> {{orcamento.valor_frete_adicional}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete_terceirizado)">
            <label>Frete tercerizado:</label>
            <strong> {{orcamento.valor_frete_terceirizado}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete_nao_cobrado_venda)">
            <label>Frete não cobrado:</label>
            <strong> {{orcamento.valor_frete_nao_cobrado_venda}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete_rota_calculado)">
            <label>Frete calculado rota:</label>
            <strong> {{orcamento.valor_frete_rota_calculado}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_frete_andar)">
            <label>Frete por andar:</label>
            <strong> {{orcamento.valor_frete_andar}} </strong>
          </div>
        </div>

        <h6 v-if="orcamento.prazo_financeira != 0">
          &nbsp;
          <a href="#"><strong>Financeira</strong></a> &nbsp;
          <i class="fas fa-dollar-sign"/>
        </h6>
        
        <div class="w3-container">
          <div class="w3-col" v-if="orcamento.prazo_financeira != 0">
            <label>Vezes:</label>
            <strong> {{orcamento.prazo_financeira}} </strong>
          </div>

          <div class="w3-col" v-if="orcamento.carencia_financeira != 0">
            <label>Carência:</label>
            <strong> {{orcamento.carencia_financeira}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_seguro_financeira)">
            <label>Valor do seguro:</label>
            <strong> {{orcamento.valor_seguro_financeira}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_tac)">
            <label>TAC:</label>
            <strong> {{orcamento.valor_tac}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_bilhete_premiado)">
            <label>Bilhete premiado:</label>
            <strong> {{orcamento.valor_bilhete_premiado}} </strong>
          </div> 
        </div>

        <h6 v-if="npz(orcamento.valor_desconto_geral)">
          &nbsp;
          <a href="#"><strong>Descontos</strong></a> &nbsp;
          <i class="fas fa-comments-dollar"/>
        </h6>
        
        <div class="w3-container">
          <div class="w3-col" v-if="npz(orcamento.perc_desconto_fechamento)">
            <label>% Desc. fechamento:</label>
            <strong> {{orcamento.perc_desconto_fechamento}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_desconto)">
            <label>Desc. fechamento:</label>
            <strong> {{orcamento.valor_desconto}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_desconto_f5)">
            <label>% Desc. do F5:</label>
            <strong> {{orcamento.valor_desconto_f5}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_desconto_f5)">
            <label>Valor desc. do F5:</label>
            <strong> {{orcamento.valor_desconto_f5}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_acrescimo_over_price)">
            <label>Valor over price:</label>
            <strong> {{orcamento.valor_acrescimo_over_price}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.perc_desconto_geral)">
            <label>% Desc. geral:</label>
            <strong> {{orcamento.perc_desconto_geral}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.valor_desconto_geral)">
            <label>Valor desc. geral:</label>
            <strong> {{orcamento.valor_desconto_geral}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.indice_over_price) > 1.00 ">
            <label>Índice over price:</label>
            <strong> {{orcamento.indice_over_price}} </strong>
          </div>

          <div class="w3-col" v-if="npz(orcamento.teve_alteracao_custo_fixo)">
            <label>Teve alt. custo fixo:</label>
            <strong> {{orcamento.teve_alteracao_custo_fixo}} </strong>
          </div> 
        </div>
      </div>
        
      <h6 
        @click="mostrarPagamentos()" 
        v-if="(orcamento.pedido_fechado == 'S') && !mostrar_pagamentos" 
        class="fundo-cabecalho ">&nbsp;
        <span>
          <i class="fas fa-sort"/>
        </span>&nbsp;
        <i class="fas fa-credit-card"/>&nbsp;&nbsp;
        <a href="#">Formas de pagamento</a>
      </h6>
        
      <h6 
        @click="mostrarPagamentos()" 
        v-if="(orcamento.pedido_fechado == 'S') && mostrar_pagamentos" 
        class="fundo-cabecalho">&nbsp;
        <span>
          <i class="fas fa-sort-down"/>
        </span>&nbsp;
          <i class="fas fa-credit-card"/>&nbsp;&nbsp;
          <a href="#">Formas de pagamento</a>
      </h6>
        
      <div v-if="mostrar_pagamentos" class="w3-animate-zoom w3-container">
          <div>
            <h5 class="titulo texto-vermelho" align="center">Formas de recebimento do pedido</h5>
          </div>  
          
        <div class="w3-container w3-border pagamentos" align="left">
          <div style="margin-bottom: 5px;"/>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_dinheiro)">
            <label>Dinheiro:</label>
            <strong>{{orcamento.valor_dinheiro}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_pix)">
            <label>Pix:</label>
            <strong>{{orcamento.valor_pix}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_cheque_vista)">
            <label>Cheque à vista:</label>
            <strong>{{orcamento.valor_cheque_vista}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_cartao_db)">
            <label>Cartão de DB:</label>
            <strong>{{orcamento.valor_cartao_db}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_cheque_prazo)">
            <label>Cheque à prazo:</label>
            <strong>{{orcamento.valor_cheque_prazo}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_cartao_cr)">
            <label>Cartão de CR:</label>
            <strong>{{orcamento.valor_cartao_cr}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_boleta)">
            <label>Boleto:</label>
            <strong>{{orcamento.valor_boleta}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_duplicata)">
            <label>Duplicata:</label>
            <strong>{{orcamento.valor_duplicata}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_financeira)">
            <label>Financeira:</label>
            <strong>{{orcamento.valor_financeira}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_acumulativo)">
            <label>Acumulativo:</label>
            <strong>{{orcamento.valor_acumulativo}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_credito)">
            <label>Crédito utilizado:</label>
            <strong>{{orcamento.valor_credito}}</strong>
          </div>

          <div class="w3-col s12 m3 l3" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_credito_gerado)">
            <label>Crédito a ser gerado:</label>
            <strong>{{orcamento.valor_credito_gerado}}</strong>
          </div>

          <div class="w3-col s12" style="margin-bottom: 5px;" v-if="npz(orcamento.valor_total_pagamentos)">
            <strong>Total pagamentos:</strong>
            <strong 
              v-if="npz(orcamento.valor_total_pagamentos)" 
              class="texto-verde">R${{orcamento.valor_total_pagamentos}}
            </strong>
            <strong v-else class="texto-vermelho">R${{orcamento.valor_total_pagamentos}}</strong>
          </div>
          
          <div class="w3-row" style="margin-bottom: 5px;" v-show="titulos.length > 0">
            <h5 class="titulo texto-vermelho" align="center">Títulos</h5>
          </div>
          
          <div 
            :key="titulo.financeiro_id"
            v-for="titulo in titulos" 
            class="w3-border pagamentos w3-container w3-margin-bottom">
            
            <div class="w3-col s12 m6" style="margin-top: 5px;">
              <label>Tipo:</label>
              <strong>{{titulo.tipo_analitico}}</strong>
            </div>

            <div class="w3-col s12 m6">
              <label>Nr. documento:</label>
              <strong>{{titulo.documento}}</strong>
            </div>

            <div class="w3-col s12 m6">
              <label>Vencimento:</label>
              <strong>{{titulo.data_vencimento}}</strong>
            </div>

            <div class="w3-col s12 m6">
              <label>Valor:</label>
              <strong>R${{titulo.valor_documento}}</strong>
            </div>

            <div class="w3-col s12 m6" style="margin-bottom: 5px;">
              <label>Status:</label>
              <strong>{{titulo.status_analitico}}</strong>
            </div>
          </div>
        </div>
      </div>

      <div v-show="par_emp_gerar_bloq_proposta_orcamento == 'S'">

        <h6 
          @click="mostrarBloqueiosProposta()"
          v-if="(bloqueios_proposta.length > 0) && !mostrar_bloqueios_proposta" 
          class="fundo-cabecalho ">&nbsp;
          <span>
            <i class="fas fa-sort"/>
          </span>
          &nbsp;
          <i class="fas fa-hand-paper"/>&nbsp;
          <a href="#">Bloqueios orçamento</a>
        </h6>

        <h6 
          @click="mostrarBloqueiosProposta()" 
          v-if="(bloqueios_proposta.length > 0) && mostrar_bloqueios_proposta" 
          class="fundo-cabecalho">&nbsp;
          <span>
            <i class="fas fa-sort-down"/>
          </span>&nbsp;
          <i class="fas fa-hand-paper">
          </i>&nbsp;&nbsp;
          <a href="#">Bloqueios orçamento</a>
        </h6>

        <div v-if="mostrar_bloqueios_proposta" class="w3-animate-zoom w3-container">
          <div align="left">
            <div class="w3-row">
              <h5 class="titulo texto-vermelho" align="center">Bloqueios orçamento</h5>
            </div>  

            <div 
              :key="index"
              v-show="bloqueios_proposta.length > 0"
              v-for="(bloqueio_proposta, index) in bloqueios_proposta"
              @click="alternarMostrarDetalhes(index, 'BLOQUEIOS_PROPOSTA')"
              :style="getStyleFundoCardExpandido(bloqueios_proposta.mostrar_detalhes)"
              class="w3-responsive w3-border pagamentos w3-margin-top w3-padding-small" >
              
              <div class="w3-col s12">
                <strong>Tipo:</strong>
                <label class="alinhamento-texto">{{bloqueio_proposta.tipo_trava_analitico}}</label>
              </div>

              <div class="w3-col s12">
                <strong>Motivo:</strong>
                <label class="alinhamento-texto">{{bloqueio_proposta.motivo}}</label>
              </div>

              <div class="w3-col s12 w3-center" v-show="!bloqueio_proposta.mostrar_detalhes">
                <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"/>
              </div> 
                
              <div v-show="bloqueio_proposta.mostrar_detalhes">
                <div class="w3-col s12" v-show="bloqueio_proposta.observacao">  
                  <strong>Observação:</strong>
                  <label>{{bloqueio_proposta.observacao}}</label>
                </div>

                <div class="w3-col s12">  
                  <strong>Informação adicional:</strong>
                  <label>{{bloqueio_proposta.informacao_adicional}}</label>
                </div>

                <div class="w3-col s12" v-show="bloqueio_proposta.nome_usuario_liberacao">  
                  <strong>Usuário de liberação:</strong>
                  <label>{{bloqueio_proposta.nome_usuario_liberacao}}</label>
                </div>

                <div class="w3-col s12" v-show="bloqueio_proposta.data_hora_liberacao">  
                  <strong>Data hora liberação:</strong>
                  <label>{{bloqueio_proposta.data_hora_liberacao}}</label>
                </div>
              </div>
                
            </div>
          </div>
        </div>
      </div>

      <h6 
        @click="mostrarBloqueios()" 
        v-if="(bloqueios.length > 0) && !mostrar_bloqueios"
        class="fundo-cabecalho ">
        &nbsp;
        <span>
          <i class="fas fa-sort"/>
        </span>
        &nbsp;
        <i class="fas fa-hand-paper"/>&nbsp;&nbsp;
        <a href="#">Bloqueios pedido</a>
      </h6>
      
      <h6 
        @click="mostrarBloqueios()"
        v-if="(bloqueios.length > 0) && mostrar_bloqueios"
        class="fundo-cabecalho">&nbsp;
        <span>
          <i class="fas fa-sort-down"/>
        </span>&nbsp;
        <i class="fas fa-hand-paper"/>&nbsp;&nbsp;
        <a href="#">Bloqueios pedido</a>
      </h6>
      
      <div v-if="mostrar_bloqueios" class="w3-animate-zoom w3-container">
        <div align="left">
          <div class="w3-row">
            <h5 class="titulo texto-vermelho" align="center">Bloqueios pedido</h5>
          </div>  

          <div
            :key="index"
            v-show="bloqueios.length > 0"
            v-for="(bloqueio, index) in bloqueios"
            @click="alternarMostrarDetalhes(index, 'BLOQUEIOS')"
            :style="getStyleFundoCardExpandido(bloqueio.mostrar_detalhes)"
            class="w3-responsive w3-border pagamentos w3-margin-top w3-padding-small">

            <div class="w3-col s12">
              <strong>Tipo:</strong>
              <label class="alinhamento-texto">{{bloqueio.tipo_trava_analitico}}</label>
            </div>

            <div class="w3-col s12">
              <strong>Motivo:</strong>
              <label class="alinhamento-texto">{{bloqueio.motivo}}</label>
            </div>

            <div class="w3-col s12 w3-center" v-show="!bloqueio.mostrar_detalhes">
              <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"/>
            </div> 
              
            <div v-show="bloqueio.mostrar_detalhes">
              <div class="w3-col s12" v-show="bloqueio.observacao">  
                <strong>Observação:</strong>
                <label>{{bloqueio.observacao}}</label>
              </div>

              <div class="w3-col s12">  
                <strong>Informação adicional:</strong>
                <label style="word-wrap: normal;">{{bloqueio.informacao_adicional}}</label>
              </div>

              <div class="w3-col s12" v-show="bloqueio.nome_usuario_liberacao">  
                <strong>Usuário de liberação:</strong>
                <label>{{bloqueio.nome_usuario_liberacao}}</label>
              </div>

              <div class="w3-col s12" v-show="bloqueio.data_hora_liberacao">  
                <strong>Data hora liberação:</strong>
                <label>{{bloqueio.data_hora_liberacao}}</label>
              </div>
            </div>
                  
          </div>
        </div>
      </div>
      <h6 
        @click="mostrarItens()" 
        v-if="!mostrar_itens" 
        class="fundo-cabecalho">&nbsp;
        <span>
          <i class="fas fa-sort"/>
        </span>&nbsp;
        <i class="fas fa-shopping-cart"/> &nbsp;
        <a href="#">Itens</a>
      </h6>
      
      <h6 
        @click="mostrarItens()" 
        v-if="mostrar_itens" 
        class="fundo-cabecalho">&nbsp;
        <span>
          <i class="fas fa-sort-down"/>
        </span>&nbsp;
        <i class="fas fa-shopping-cart"/>&nbsp;
        <a href="#">Itens</a>
      </h6>
      
      <div v-if="mostrar_itens" class="w3-animate-zoom w3-container">
      
        <div 
          :key="index"
          v-for="(item, index) in items"
          :style="getStyleFundoCardExpandido(item.mostrar_detalhes)"
          style="margin-top:8px!important;"
          class="w3-border card-itens w3-container w3-padding-small">
          
          <!-- legendas cores tela-->
          <legenda v-if="item.legenda_kit">
            <div>Kit</div>
            <div slot="referencia" >
              <i :style="{'color': item.legenda_kit}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda  v-else-if="item.legenda_promocao_especial" >
            <div>Promoção especial</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_promocao_especial}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_servico">
            <div>Serviço</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_servico}" class="fa fa-circle" /> 
            </div>
          </legenda>

          <legenda  v-else-if="item.legenda_usou_promocao">
            <div>Utilizou promoção</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_usou_promocao}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_nao_permite_venda_sem_previsao">
            <div>Não permite venda sem Previsão</div>
            <div  slot="referencia" >
              <i :style="{'color': item.legenda_nao_permite_venda_sem_previsao}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_desativar_produto_zerar_estoque">
            <div>Desativar produto ao zerar o estoque</div>
            <div slot="referencia" >
              <i :style="{'color': item.legenda_desativar_produto_zerar_estoque}" class="fa fa-circle" />
            </div>
          </legenda>
            
          <legenda v-else-if="item.legenda_bloqueado_para_venda">
            <div>Bloqueado para venda</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_bloqueado_para_venda}" class="fa fa-circle" />
            </div>
          </legenda>
            
          <legenda v-else-if="item.legenda_ponta_estoque">
            <div>Ponta de estoque</div>
            <div slot="referencia" ><i :style="{'color': item.legenda_ponta_estoque}" class="fa fa-circle" /></div>
          </legenda>

          <legenda  v-else-if="item.legenda_produto_inativo">
            <div>Produto inativo</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_produto_inativo}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_produto_com_preco_vencido">
            <div>Produto com preço vencido</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_produto_com_preco_vencido}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_utiliza_indice_preco_cond_pagt">
            <div>Utiliza índice de preço da condição de pagamento</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_utiliza_indice_preco_cond_pagt}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda  v-else-if="item.legenda_produto_sob_encomenda">
            <div>Produto sob encomenda</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_produto_sob_encomenda}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_comissao_especial">
            <div>Comissão especial</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_comissao_especial}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_retirar_lojas_rede">
            <div>Retirar de lojas rede</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_retirar_lojas_rede}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_venda_impulso">
            <div>Venda por impulso</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_venda_impulso}" class="fa fa-circle" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_promocao_relampago">
            <div>Utilizou promoção relâmpago</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_promocao_relampago}" class="fas fa-bolt" />
            </div>
          </legenda>

          <legenda v-else-if="item.legenda_calcular_peso_venda">
            <div>Calculou peso na venda</div>
            <div slot="referencia">
              <i :style="{'color': item.legenda_calcular_peso_venda}" class="fa fa-circle" />
            </div>
          </legenda>


          <div @click="alternarMostrarDetalhes(index, 'ITENS')">

            <strong class="texto-vermelho" style="font-size: 13px;">
              {{item.produto_id}} - <span style="letter-spacing: .5px">{{item.nome}}</span>
            </strong>

            <div class="w3-col s12" style="font-size: 13px">
              <label>Unidade: </label>
              <strong class="cor-fonte-car-itens">{{item.unidade}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px">
              <label>Quantidade: </label>
              <strong class="cor-fonte-car-itens">{{item.quantidade}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px">
              <label>Preço unit: </label>
              <strong class="cor-fonte-car-itens">{{item.preco_venda}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px">
              <label>Total do item: </label>
              <strong style="color: #03bf00">R$ {{item.valor_total}}</strong>
            </div>

            <div class="w3-col s12 w3-center" v-show="!item.mostrar_detalhes">
              <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"/>
            </div>

          </div>

          <thead v-show="item.mostrar_detalhes" @click="alternarMostrarDetalhes(index, 'ITENS')">
            <div class="w3-col s12" style="font-size: 13px">
              <label>Vlr. Desc/acresc. (F5): </label>
              <strong class="cor-fonte-car-itens">{{item.valor_desconto_preco_manual}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px">
              <label>Total do item líquido: </label>
              <strong class="cor-fonte-car-itens">{{item.valor_total_liquido}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="item.entregues">
              <label>Entregues: </label>
              <strong class="cor-fonte-car-itens">{{item.entregues}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="item.pendentes">
              <label>Pendência: </label>
              <strong class="cor-fonte-car-itens">{{item.pendentes}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="item.devolvidos">
              <label>Devolvidos: </label>
              <strong class="cor-fonte-car-itens">{{item.devolvidos}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="item.bloqueado">
              <label>Bloqueado: </label>
              <strong class="cor-fonte-car-itens">{{item.bloqueados}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="item.retirar_loja_rede_analitico">
              <label>Retirar lojas rede: </label>
              <strong class="cor-fonte-car-itens">{{item.retirar_loja_rede_analitico}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="npz(item.empresa_retirar_lojas_rede_id)">
              <label>Empresa retirar lojas rede: </label>
              <strong class="cor-fonte-car-itens">{{item.empresa_retirar_lojas_rede_id}} - {{item.nome_empresa_retira_loja_rede}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="item.impulso">
              <label>Impulso: </label>
              <strong class="cor-fonte-car-itens">{{item.impulso}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="npz(item.valor_desconto_preco_manual)">
              <label>Vlr. Desc/acresc. (F5): </label>
              <strong class="cor-fonte-car-itens">{{item.valor_desconto_preco_manual}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="npz(item.perc_desconto_preco_manual)">
              <label>% Desc/acresc. (F5): </label>
              <strong class="cor-fonte-car-itens">{{item.perc_desconto_preco_manual}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="npz(item.valor_preco_promo_manual)">
              <label>Vlr desc. pço prom. manual: </label>
              <strong class="cor-fonte-car-itens">{{item.valor_preco_promo_manual}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="npz(item.perc_preco_promo_manual)">
              <label>% Desc. pço prom. manual: </label>
              <strong class="cor-fonte-car-itens">{{item.perc_preco_promo_manual}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="npz(item.valor_preco_ponta_estoque_manual)">
              <label>Vlr desc. ponta estoque manual: </label>
              <strong class="cor-fonte-car-itens">{{item.valor_preco_ponta_estoque_manual}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px" v-if="npz(item.perc_preco_ponta_est_manual)">
              <label>% Desc. pço ponta estoque manual: </label>
              <strong class="cor-fonte-car-itens">{{item.perc_preco_ponta_est_manual}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px">
              <label>Preço base: </label>
              <strong class="cor-fonte-car-itens">{{item.preco_base}}</strong>
            </div>

            <div class="w3-col s12" style="font-size: 13px">
              <label>Total base: </label>
              <strong class="cor-fonte-car-itens">{{item.total_base}}</strong>
            </div>
          </thead>
        </div>

        <div class="w3-row-padding cabecalho w3-margin-top" style="padding: 0px;">
          <div class="w3-col m6 l4 s12">
            <label>Qtd. itens:</label>
            <strong> {{rodape_itens.quantidade_itens}} </strong>
          </div>

          <div class="w3-col m6 l4 s12">
            <label>Peso total:</label>
            <strong> {{rodape_itens.peso_total}} </strong>
          </div>

          <div class="w3-col m6 l4 s12">
            <label>Prod. sem promoção:</label>
            <strong> {{rodape_itens.total_sem_promocao}} </strong>
          </div>

          <div class="w3-col m6 l4 s12">
            <label>Produtos com promoção:</label>
            <strong> {{rodape_itens.total_com_promocao}} </strong>
          </div>

          <div class="w3-col m6 l4 s12">
            <label>Tot. base:</label>
            <strong> {{rodape_itens.total_base}} </strong>
          </div>

          <div class="w3-col m6 l4 s12">
            <label>Tot. serviços:</label>
            <strong> {{rodape_itens.total_servico}} </strong>
          </div>

          <div class="w3-col m6 l4 s12">
            <label>Serv. sem promoção:</label>
            <strong> {{rodape_itens.total_sem_promocao_servico}} </strong>
          </div>  

          <div class="w3-col m6 l4 s12">
            <label>Serv. com promoção:</label>
            <strong> {{rodape_itens.total_servico_com_promocao}} </strong>
          </div>

          <div class="w3-col m6 l4 s12">
            <label>Tot. dos produtos:</label>
            <strong> {{rodape_itens.total_produtos}} </strong>
          </div>                 
        </div>

      </div>

      <!-- modal legendas-->
      <div class="w3-container">
      <footer class="w3-container  w3-center">
        <button 
          class="w3-btn w3-theme" 
          id="btn-confirmar-acao" 
          style="margin-top: 10px; margin-bottom:10px;" 
          @click="buscarMix(orcamento.orcamento_id)">
          <i class="fas fa-chart-pie"/>&nbsp;
          Visualizar Mix
        </button>
      </footer>
    </div>
  </div>

  <modal-mix 
    :mix="mix" 
    v-if="mostrarModalMix" 
    @close="mostrarModalMix = false"
  />
</div>
</template>

<script>
  import Legenda from '@/components/Legendas'
  import ModalMix from '@/components/ModalMix'
  import RBuscarMix from '@/components/Rest/RBuscarMix.js'
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoBuscarDadosOrcamento from '@/components/Rest/ROrcamento/ROrcamentoBuscarDadosOrcamento.js'

  export default {
    name: 'DadosOrcamento',
    props: ['orcamento_dados'],
    components: {
      ModalMix,
      Legenda
    },    
    mixins:[formatarValorMixin],
    data() {
      return {
        api: process.env.API,
        rodape_itens: '',
        status_orcamento: '',
        items: '',
        orcamento: '',
        abrirModalLegendas: false,
        tabAtiva: 2,
        orcamento: {},
        items: [],
        bloqueios: [],
        bloqueios_proposta: [],
        titulos: [],
        status_orcamento: {},
        rodape_itens: {},
        mix: {},
        mostrarModalMix: false,
        mostrar_gerais: true,
        mostrar_itens: false,
        mostrar_bloqueios: false,
        mostrar_bloqueios_proposta: false,
        mostrar_pagamentos: false,
        par_emp_gerar_bloq_proposta_orcamento: '',
        tags:[
        
        ]
      }
    },
    watch: {
      mostrarModalMix(){
        this.verificarModalAberto()
      }
    }, 

    mounted() {
      this.preencherDadosOrcamento(); 
    },

    methods: {
      mostrarItens(){
        this.mostrar_itens = !this.mostrar_itens;
      },

      mostrarBloqueios(){
        this.mostrar_bloqueios = !this.mostrar_bloqueios;
      },
      
      mostrarBloqueiosProposta(){
        this.mostrar_bloqueios_proposta = !this.mostrar_bloqueios_proposta;
      },
      
      mostrarPagamentos(){
        this.mostrar_pagamentos = !this.mostrar_pagamentos;
      },

      mostrarGerais(){
        this.mostrar_gerais = !this.mostrar_gerais;
      },

      alternarMostrarDetalhes(index, tipo){
        if (tipo == 'ITENS'){
          this.items[index].mostrar_detalhes = !this.items[index].mostrar_detalhes;
        } else if (tipo == 'FINANCEIRO'){
          this.titulos[index].mostrar_detalhes = !this.titulos[index].mostrar_detalhes;
        } else if (tipo == 'BLOQUEIOS'){
          this.bloqueios[index].mostrar_detalhes = !this.bloqueios[index].mostrar_detalhes;
        } else if (tipo == 'BLOQUEIOS_PROPOSTA'){
          this.bloqueios_proposta[index].mostrar_detalhes = !this.bloqueios_proposta[index].mostrar_detalhes;
        }

        this.$forceUpdate();
      },

      verificarModalAberto(){
        const el = document.documentElement
        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        }
      },      

      async buscarMix(orcamento_id){
        try {
	
          let parametros = {
            orcamento_id: orcamento_id
          }

          let retorno = await RBuscarMix.buscarMix(this.axios, parametros);

          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }

          this.mix = retorno.dados;
          this.mostrarModalMix = true;
        } catch (error) {
          this.verificarErro(error, 'buscarMix');
        }
      }, 

      async preencherDadosOrcamento(){
        try {
          let parametros = {
            orcamento_id: this.orcamento_dados,
          }

          let retorno = await ROrcamentoBuscarDadosOrcamento.buscarDadosOrcamento(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          let dados = retorno.dados;
          this.rodape_itens = dados.rodape_itens[0];
          this.status_orcamento = dados.status_orcamento[0];
          this.items = dados.orcamento_itens;
          this.orcamento = dados.orcamento_gerais[0];
          this.titulos = dados.orcamento_titulos;
	        this.bloqueios = dados.pedido_bloqueios;
          this.bloqueios_proposta = dados.proposta_bloqueios;
          this.par_emp_gerar_bloq_proposta_orcamento = dados.par_emp_gerar_bloq_proposta_orcamento;
        } catch (error) {
          this.verificarErro(error, 'preencherDadosOrcamento');
        }
      },

      getStyleFundoCardExpandido(mostrar_detalhes){
        return mostrar_detalhes ? 'border: 1px solid #bfbfbf; box-shadow: #7a7a7a 1px 2px 5px 2px;' : 'background-color: white';
      },

      verificarErro(erro, nome_funcao){
        Biblioteca.gerarLogNomeFuncao('DadosOrcamento.vue -> ' + nome_funcao);
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },
    },
  }
</script>

<style scoped>

  .container-items-topo {
    position: relative;
    display: flex;
    text-align: center;
    overflow: auto;
    margin: 0 auto;
  }

  .items-topo {
    padding: 5px 10px;
    display: inline-block;
    white-space: nowrap;
    margin: 10px 4px;
    background: #9c1d1c;
    color: #fff;
    border-radius: 10px;
    font-size: 0.8em;
  }

  .content {
    max-height: 40vh;
    overflow: auto;
    border: 1px solid #ccc;
  }

  .tabs {
    overflow: hidden;
    margin-left: 20px;
    margin-bottom: -2px; 
  }

  .tabs ul {
    list-style-type: none;
    margin-left: 20px;
  }

  .tabs a{
    float: left;
    padding-left: 3px;
    cursor: pointer;
    /*padding: 10px 24px;*/
    text-align: center;
    display: inline;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #f1f1f1;
    border-radius: 50px 50px 50px 50px;
    font-weight: bold;
    width: 50px;
    height: 50px;
  }
  .tabs a:last-child { 
    border-right: 1px solid #ccc;
  }

  /* Change background color of tabs on hover */
  .tabs a:hover {
    background-color: #aaa;
    color: #fff;
  }

  /* Styling for active tab */
  .tabs a.active {
    background-color: #fff;
    border-radius: 50px 50px 50px 50px;
    color: #484848;
    width: 50px;
    height: 50px;
    display: inline;
    text-align: left;
    cursor: default;
  }

  /* Style the tab content */
  .tabcontent {
    padding: 10px;
    box-shadow: 3px 3px 6px #e1e1e1
  }

  .tabs-items {
    border-radius: 50px 50px 50px 50px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    border-bottom: 0px dotted #666666;
    color:#9c1d1c;
    background-color: #f3f3f3;
    text-align:center;
    padding-top: 5%;
    width:50px;
    height:50px;
    font-size: 25px;
    margin-left:5%;
  }

  .w3-card {
    padding: 10px;
    box-shadow: none !important;
  }

  .card-dashboard {
    border-radius: 10px;
    /* background-color: #e6e6e6; */
    padding: 5px;
    position: relative;
    display: table;
    text-align: center;
    font-size: 0.9em;
    height: 50px;
  }

  .soma {
    font-size: 1.5em
  }

  .cabecalho > .w3-col > input{
    padding: 0px 0px;
  }

  @media only screen and (max-width: 425px) {
    .tabs-items{
      /* padding: 10px 15px !important; */
    }
    .tabcontent {
    /* padding: 5px*/
    }
  }

  .th-items {
    white-space: nowrap;
  }
  .items > td {
    text-align: center;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd; 
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }

  .card-itens{
    border-radius: 10px 10px 10px 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    border-bottom: 0px dotted #666666;
  }

  .card-item {
    margin-top: 0 !important
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%
  }

  .card-informacoes-selecionado {
    border-left-color : #a20000 !important
  }

  .card-informacoes:hover {
    background: #eeeeee
  }

  .card {
    margin-bottom: 10px;
    border-radius: 15px;
    float: left;
    padding: 7px;
    cursor: pointer;
    transition: 0.2s;
    width: 100%;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
  }
  
  .texto-verde{
    color: green;
  }

  .fundo-cabecalho {
    background-color: #9c1d1c;
    color: white;
    margin-left: 2px;
    border-radius: 5px;
    font-size: 14px;
  }

  .carousel {
    align-items: center;
    background-color: #666;
    color: #999;
    display: flex;
    font-size: 1.5rem;
    justify-content: center;
    min-height: 10rem;
  }

  .pagamentos{
    border-radius: 10px 10px 10px 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
  }

</style>


// WEBPACK FOOTER //
// src/components/Orcamentos/DadosOrcamento.vue